import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IMerchantRequestValidationDataTableRowFormMeta {
  applicationId: FormInputMeta,
  applicationDate: FormInputMeta,
  merchant: FormInputMeta,
  classNumber: FormInputMeta,
  decisionDate: FormInputMeta,
  decidedBy: FormInputMeta,
  merchantProduct: FormInputMeta,
  ADI: FormInputMeta,
  //
  client: FormInputMeta,
  agency: FormInputMeta,
  merchantProductName: FormInputMeta,
  //
  schema: any,
}

const MerchantRequestValidationDataTableRowFormMeta = {} as IMerchantRequestValidationDataTableRowFormMeta;

MerchantRequestValidationDataTableRowFormMeta.applicationId = {
  name: 'applicationId',
  type: 'text',
  label: 'ID Application',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.applicationDate = {
  name: 'applicationDate',
  type: 'text',
  label: 'Date application',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.merchant = {
  name: 'merchant',
  type: 'text',
  label: 'Commercant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.classNumber = {
  name: 'classNumber',
  type: 'text',
  label: 'N° Classe',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.decisionDate = {
  name: 'decisionDate',
  type: 'date',
  label: 'Date décision',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.decidedBy = {
  name: 'decidedBy',
  type: 'text',
  label: 'Decidé par',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.merchantProduct = {
  name: 'merchantProduct',
  type: 'text',
  label: 'Produit commercant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.ADI = {
  name: 'ADI',
  label: 'ADI',
  type: 'select',
  options:  [
    {
      label: 'A',
      value: 'a'
    },
    {
      label: 'D',
      value: 'd',
    },
    {
      label: 'I',
      value: 'i',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

// *********************************************

MerchantRequestValidationDataTableRowFormMeta.client = {
  name: 'client',
  type: 'text',
  label: 'Client',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.agency = {
  name: 'agency',
  type: 'text',
  label: 'Agence',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
MerchantRequestValidationDataTableRowFormMeta.merchantProductName = {
  name: 'merchantProductName',
  type: 'text',
  label: 'Produit Commercant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

MerchantRequestValidationDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(MerchantRequestValidationDataTableRowFormMeta));

export default MerchantRequestValidationDataTableRowFormMeta;
